import _ from "lodash";
import { VirkeskopAtgardsgrupper } from "~app/common/models/constants";
import { Atgard } from "./../atgard-models";
import { isSiktrojning, IVKAtgardKedjaKoppling, IVKAtgardKedjaKopplingMasshanteringsResponseDTO, mapKedjekopplingFromMasshantering } from "./atgardskedjor-models";

export class VKAtgardKedja {
    kedjaGuid: string;
    kedjaRowVersion: string;
    kedjaKopplingar: IVKAtgardKedjaKoppling[] = [];

    constructor(
        kedjaGuid: string
    ) {
        this.kedjaGuid = kedjaGuid;
    }

    static createKedjaFromMasshantering(kopplingar: IVKAtgardKedjaKopplingMasshanteringsResponseDTO[]): VKAtgardKedja {
        const kedja = new VKAtgardKedja(kopplingar[0].kedjaGuid);
        kedja.kedjaRowVersion = kopplingar[0].kedjaRowVersion;

        kedja.kedjaKopplingar = kopplingar.map(koppling => mapKedjekopplingFromMasshantering(koppling));
        kedja.setLopnummer();
        return kedja;
    }

    addExistingKedjakoppling(nyKoppling: IVKAtgardKedjaKoppling): void {
        this.kedjaKopplingar.push(nyKoppling);
        this.kedjaRowVersion = nyKoppling.kedjaRowVersion;
    }

    containsAtgardGuid(atgardGuid: string): boolean {
        return !!this.kedjaKopplingar.find(koppling => koppling.atgardGuid === atgardGuid);
    }

    createNewKoppling(avtalID: number, kontraktId: number, atgard: Atgard) {
        const koppling = this.createkoppling(avtalID, kontraktId, atgard);
        this.kedjaKopplingar.push(koppling);
        this.sortKopplingar();
    }

    removeKoppling(atgardGuid: string) {
        const kopplingIndex = this.kedjaKopplingar.findIndex(koppling => koppling.atgardGuid === atgardGuid);
        if (kopplingIndex > -1) {
            this.kedjaKopplingar.splice(kopplingIndex,1);
            this.sortKopplingar();
        }
    }

    reorderKopplingsKedja(): void {
        this.sortKopplingar();
    }

    getDisplayKopplingar(): IVKAtgardKedjaKoppling[] {
        return this.kedjaKopplingar;
    }

    //kopplar på en atgard på en befintlig kedja
    private createkoppling(avtalID: number, kontraktId: number, atgard: Atgard): IVKAtgardKedjaKoppling {
        return {
            avtalId: avtalID,
            kontraktId: kontraktId,
            kedjaGuid: this.kedjaGuid,
            atgardGuid: atgard.guid,
            atgardId: atgard.id,
            beteckning: atgard.beteckning,
            atgardsgrupp: atgard.atgardsgrupp,
            atgardstyp: atgard.atgardstyp,
            lopnummer: this.kedjaKopplingar.length + 1, //Default lopnummer för att sortering av inbördesordning
            kedjaRowVersion: this.kedjaRowVersion
        };
    }

    private sortKopplingar(): void {
        this.kedjaKopplingar = _.orderBy(this.kedjaKopplingar,x => this.sortindex(x));
        this.setLopnummer();
    }

    private setLopnummer(): void {
        let index = 1;
        this.kedjaKopplingar.forEach(koppling => {
            koppling.lopnummer = index;
            index++;
        });
    }

    private sortindex(kedjaKoppling: IVKAtgardKedjaKoppling): number {
        if (isSiktrojning(kedjaKoppling)) {
            return 0;
        }
        switch (kedjaKoppling.atgardsgrupp) {
            case VirkeskopAtgardsgrupper.Avverkning:
                return 1;
            case VirkeskopAtgardsgrupper.Leveransvirke:
                return 2;
            case VirkeskopAtgardsgrupper.Grot:
                return 3;
            default:
                return 4;
        }
    }
}
